import React from "react"
import { FormattedMessage, } from "react-intl"
import AccountStatement from "../../../customer/account-statement/model/AccountStatement"

type OwnProps = {
    accountStatement: AccountStatement,
}

const AccountStatementSentComponent = (props: OwnProps) => {

    return <div className={"row"}>
        <div
            className="col-12"
            data-document-event="account-statement-sent">
            <FormattedMessage
                id="quote.events.account_statement_sent.text"
                defaultMessage="Account Statement {identifier} has been sent"
                values={{
                    identifier: props.accountStatement.getIdentifier()
                }}
            />
        </div>
    </div>
}

export default AccountStatementSentComponent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/account-statement-sent.component.tsx